<template>
  <div class="tw-mx-auto">
    <TwModal
      v-if="showQuantityNameConfirm"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="handleQuantityConfirmCancel"
    >
      <template #body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Add Items with the Same Name?</h2>
          <button
            type="button"
            class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
            @click="handleQuantityConfirmCancel"
            aria-label="Close"
          >
            &times;
          </button>
          <p class="tw-mx-8 tw-mb-8 tw-text-3xl tw-text-center !tw-leading-relaxed">
            You are adding {{ state.quantity }} of this item with the same name:
          </p>
          <p class="tw-mx-8 tw-text-4xl tw-font-bold tw-text-center !tw-leading-relaxed">{{ state.recipient }}</p>
        </div>
      </template>
      <template #footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8 lg:tw-mb-4">
          <TwButton
            cssClass="tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-bg-orange-medium hover:tw-border-orange-medium hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            :isLoading="false"
            :isDisabled="false"
            :buttonText="'Go Back'"
            @emit-click="handleQuantityConfirmCancel"
          />
          <TwButton
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
            :isLoading="false"
            :isDisabled="false"
            :buttonText="'Continue Adding'"
            @emit-click="handleQuantityConfirmContinue"
          />
        </div>
      </template>
    </TwModal>
    <div class="md:tw-flex">
      <div class="tw-flex-1 tw-grow tw-text-center tw-border-t-2 tw-border-r-2 tw-boder-gray-700">
        <div class="tw-px-4 lg:tw-px-12 tw-py-8 tw-text-left">
          <template v-if="state.loadingProduct">
            <SkeletonLoader class="tw-w-1/3 tw-h-8" />
          </template>
          <template v-else>
            <RouterLink to="/menu" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">Menu</RouterLink> >
            <template v-if="router.options && router.options.history && router.options.history.state && router.options.history.state.back && router.options.history.state.back == '/menu/categories'">
              <RouterLink 
                :to="{ name: 'all-categories' }"
                class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">
                  All Categories
                </RouterLink> >
            </template>
            <template v-else-if="state.parentCategory">
              <RouterLink 
                :to="{ name: 'category', params: { id:  state.parentCategory.id}}"
                class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2 hover:tw-text-orange-medium">
                  {{state.parentCategory.name}}
                </RouterLink> >
            </template>
            <span v-if="state.product" class="tw-uppercase tw-text-lg lg:tw-text-2xl tw-font-bold tw-px-2">{{state.product.name}}</span>
          </template>
        </div>

        <template v-if="state.loadingProduct">
          <SkeletonLoader class="tw-w-full tw-h-96 tw-mb-16" />
          <div class="tw-px-16">
            <SkeletonLoader class="tw-mx-auto tw-w-2/3 tw-h-16 tw-mb-4" />
            <SkeletonLoader class="tw-mx-auto tw-w-full tw-h-6 tw-mb-2" />
            <SkeletonLoader class="tw-mx-auto tw-w-full tw-h-6 tw-mb-2" />
            <SkeletonLoader class="tw-mx-auto tw-w-2/3 tw-h-6 tw-mb-12" />
            <SkeletonLoader class="tw-mx-auto tw-w-1/4 tw-h-16 tw-rounded-full tw-mb-4" />
          </div>
        </template>

        <template v-else>
          <div class="tw-mb-16" v-if="state.product && productHero">
            <img 
              :alt="state.product.name+' image'"
              class="tw-w-full group-hover:tw-scale-125 tw-transition-all tw-duration-300 tw-ease-out"
              :src="productHero">
          </div>
        
          <div class="tw-px-8 tw-mb-0 md:tw-pb-24 lg:tw-pb-32">
            <h2 class="tw-text-6xl tw-font-bold tw-mb-4" v-if="state.product">{{state.product.name}}</h2>
            <div class="tw-text-gray-700 tw-font-bold tw-mb-4">
              <span v-if="state.product && state.product.cost"> ${{currentPrice.toLocaleString("en-US", {minimumFractionDigits: 2})}}</span> <span v-if="state.product && state.product.feeds">| Each Serves {{Math.round(metaFeeds / state.quantity)}}</span>
            </div>
            <p class="tw-mb-16" v-if="state.product && state.product.description">
              {{state.product.description}}
            </p>
            <TwButton 
              cssClass="tw-bg-orange-medium hover:tw-bg-orange-dark tw-border-orange-medium tw-border-2 tw-hidden md:tw-inline-block tw-rounded-full tw-text-white tw-text-2xl tw-uppercase tw-font-bold tw-px-12 tw-mb-4 tw-py-6 tw-transition-all tw-duration-200" 
              @emit-click="addItem" 
              :isLoading="state.addingToBag"
              :isDisabled="false" 
              :buttonText="state.basketProduct != null ? 'Update Item' : 'Add To Order'"/>
          </div>

          <template v-if="state.debug && state.product">
            <div class="tw-border-b tw-border-gray-700 tw-py-16">
              <h1>selectedOptions</h1>
              {{state.selectedOptions}}
            </div>

            <div class="tw-border-b tw-border-gray-700 tw-py-16" v-if="visibleNestedGroupIds">
              <h1>Visible Option Groups</h1>
              {{visibleNestedGroupIds}}
            </div>
            <div class="tw-border-b tw-border-gray-700 tw-py-16">
              <h1>Visible Option Groups</h1>
              {{visibleOptionGroups.map((og) => [og.id, og.description, og.rootGroupId])}}
            </div>
            <div class="tw-border-b tw-border-gray-700 tw-py-16" v-if="state.product.optiongroups">
              <h1>Option Groups</h1>
              {{state.product!.optiongroups.map((og) => [og.id, og.description, og.parentId])}}
            </div>
            <div class="tw-border-b tw-border-gray-700 tw-py-16" >
              <h1>Included Ingredients</h1>
              {{state.includedIngredients}}
            </div>
            <div class="tw-border-b tw-border-gray-700 tw-py-16">
              <h1>basketProduct</h1>
              {{state.basketProduct != null && typeof(state.basketProduct) != 'undefined' && typeof(state.basketProduct.id) != 'undefined'}}
            </div>
            <div class="tw-border-b tw-border-gray-700 tw-py-16">
              <h1>Product</h1>
              {{state.product}}
            </div>
          </template>
        </template>
      </div>
      
      <div class="tw-flex-1 tw-grow">
        <div class="tw-max-w-7xl">
          <template v-if="state.loadingProduct">
            <SkeletonLoader class="tw-w-full" />
            <div class="tw-px-16 tw-pt-4 tw-pb-32">
              <SkeletonLoader class="tw-w-2/3 tw-h-16 tw-mb-2" />
              <SkeletonLoader class="tw-w-1/2 tw-h-6 tw-mb-8" />

              <div class="tw-border-b tw-border-gray-700 tw-pb-16 tw-grid tw-gap-8 tw-grid-cols-2 tw-mb-12 ">  
                <SkeletonLoader
                  class="tw-my-1 tw-px-1 tw-h-24 tw-w-full"
                  v-for="idx in 12" 
                  :key="'loader-'+idx" />
              </div>

              <SkeletonLoader class="tw-w-1/3 tw-h-16 tw-mb-2" />
              <SkeletonLoader class="tw-w-1/4 tw-h-6 tw-mb-8" />

              <div class="tw-border-b tw-border-gray-700 tw-pb-16 tw-grid tw-gap-8 tw-grid-cols-2 tw-mb-12 ">  
                <SkeletonLoader
                  class="tw-my-1 tw-px-1 tw-h-24 tw-w-full"
                  v-for="idx in 12" 
                  :key="'loader-'+idx" />
              </div>

            </div>
          </template>

          <template v-else>
            <div v-if="state.product" class="tw-px-8 lg:tw-px-16 tw-pt-4 tw-pb-32">

              <template 
                v-for="(optionGroup , index) in state.product.optiongroups" 
                :key="'og-'+(optionGroup as OptionGroupInterface)!.id"
                >
              
                <OptionGroup
                  :class="[{'tw-pt-0 md:tw-mt-24': index == 0}, {'tw-mt-24 tw-border-t tw-border-t-gray-700 tw-pt-16 tw-mt-16': optionGroup.parentId == null && index != 0 }]"
                  :selectedOptions="state.selectedOptions"
                  :optionGroup="optionGroup"
                  :isFirst="index == 0"
                  :modularNutritionData="modularNutritionData! as Boolean"
                  :layoutType="'full'"
                  @optionAdded="selectOption"
                  @optionRemoved="removeOption"
                />

                <template v-if="modularNutritionData && shouldDisplayGroupNestedNutrition(optionGroup.id, getRootGroupId(optionGroup))">
                  <div class="tw-mt-12 tw-pl-16">
                    <Dietary
                      :group="''"
                      :parentOptions="''"
                      :allergens="(calculatedAllergensForGroups && calculatedAllergensForGroups.get(getRootGroupId(optionGroup)) && typeof(calculatedAllergensForGroups.get(getRootGroupId(optionGroup))) != 'undefined' && calculatedAllergensForGroups.get(getRootGroupId(optionGroup))!.length > 0) ? calculatedAllergensForGroups.get(getRootGroupId(optionGroup))! as string[] : [] as string[]"
                      :allDiets="calculatedSelectionsInGroup(getRootGroupId(optionGroup)).length < 1 ? [] as string[] : productDietCodes"
                      :diets="calculatedDietsForGroup && calculatedDietsForGroup.get(getRootGroupId(optionGroup)) ? calculatedDietsForGroup.get(getRootGroupId(optionGroup))! as string[] : [] as string[]"
                      :baseAllergens="groupAllergenLabelBuckets.get(getRootGroupId(optionGroup))?.base ?? []"
                      :sideAllergens="groupAllergenLabelBuckets.get(getRootGroupId(optionGroup))?.side ?? []"
                      :baseDiets="groupDietLabelBuckets.get(getRootGroupId(optionGroup))?.base ?? []"
                      :sideDiets="groupDietLabelBuckets.get(getRootGroupId(optionGroup))?.side ?? []"
                      :baseNames="groupSelectionNameBuckets.get(getRootGroupId(optionGroup))?.base ?? []"
                      :sideNames="groupSelectionNameBuckets.get(getRootGroupId(optionGroup))?.side ?? []"
                      :hasSideItems="groupHasSideSelections.get(getRootGroupId(optionGroup)) ?? false"
                      :layout="'group'" />
                    
                  </div>
                </template>
              </template>

              <div class="tw-border-b tw-border-gray-700 tw-py-16">
                <div v-if="showRecipientField" class="tw-border-t tw-border-gray-700 tw-pt-12">
                  <div class="tw-mb-10 tw-pr-8">
                    <div class="tw-pt-4 tw-outline tw-outline-0 tw-relative tw-border-b-2 focus-within:tw-border-orange-medium">
                      <input 
                        v-model="state.recipient"
                        type="text" 
                        name="recipient" 
                        maxlength="32"
                        placeholder=" "
                        class="tw-block tw-text-2xl tw-py-4 tw-w-full tw-border-0 tw-appearance-none focus:tw-outline-0 tw-bg-transparent tw-border-transparent focus:tw-border-transparent focus:tw-ring-0 tw-px-0" />
                      <label for="recipient" class="tw-pointer-events-none tw-absolute tw-top-0 tw-py-4 tw--z-1 tw-duration-300 tw-origin-top-left">Who is this for? (Type name here)</label>
                    </div>
                    <p class="tw-mt-2 tw-text-xl" v-if="state.recipient.length > 0">({{ 32 - state.recipient.length }} characters remaining)</p>
                  </div>
                </div>
                <div class="tw-overflow-hidden tw-rounded-lg tw-shadow-lg tw-bg-white tw-w-full tw-block tw-px-8 tw-py-8 tw-mb-16">
                  <div class="lg:tw-flex tw-items-center tw-justify-center tw-text-center">
                    <div class="tw-flex-1 tw-mx-4 tw-mb-6 lg:tw-mb-0">
                      <!-- @vue-skip -->
                       <h4 class="tw-text-3xl tw-mb-2">How many {{/\d$/.test(state.product.name) ? state.product.name : pluralizeProductName(state.product.name, 2)}} would you like?</h4>
                        <p class="tw-text-lg" v-if="metaFeeds">
                          (One {{state.product.name}} feeds {{Math.round(metaFeeds / state.quantity)}} people | +${{currentPrice.toFixed(2)}})
                        </p>
                    </div>

                    <div class="tw-flex-1 tw-mx-4 tw-flex tw-justify-center">
                      <div class="tw-flex tw-items-center tw-relative tw-max-w-xs">
                        <input 
                        v-model="state.quantity"
                        min="1"
                        increment="1"
                        class="tw-w-full tw-text-3xl tw-max-w-96 tw-text-center tw-px-16 tw-py-4 tw-border focus:tw-outline-none tw-border-gray-400 focus:tw-border-orange-medium focus:tw-ring-0 tw-rounded-full"
                        type="number">
                        <button
                          @click="decrementQuantity"
                          class="tw-px-8 tw-text-4xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black tw-absolute tw-left-0">
                          &mdash;
                        </button>

                        <button
                          @click="incrementQuantity"
                          class="tw-px-8 tw-text-4xl hover:tw-text-orange-medium tw-transition-all tw-font-bold tw-text-black tw-absolute tw-right-0 ">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 class="tw-text-3xl tw-font-black tw-mb-8">Hunger Meter</h3>
                <div class="tw-mb-4">
                  <ProgressBar 
                    :baseline="baselineCovered"
                    :percentage="percentageAccountedFor" />
                </div>

                <div class="tw-uppercase tw-text-right tw-font-black">
                 {{totalFed}}<template v-if="cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder.guest_count && cateringOrderStore.cateringOrder!.guest_count > 0"> / {{cateringOrderStore.cateringOrder!.guest_count}}</template> People Fed After Adding This Item
                </div>
              </div>

              <div class="tw-border-b tw-border-gray-700 tw-py-16" v-if="!state.dietsUnknown && !state.allergensUnknown && !modularNutritionData">
                <Dietary
                  :group="''"
                  :parentOptions="''"
                  :allergens="currentAllergens"
                    :allDiets="productDietCodes"
                  :diets="currentDietary! as string[]"
                    :baseAllergens="baseAllergenLabels"
                    :sideAllergens="sideAllergenLabels"
                    :baseDiets="baseDietLabels"
                    :sideDiets="sideDietLabels"
                    :baseNames="overallBaseOptionNames"
                    :sideNames="overallSideOptionNames"
                    :hasSideItems="hasSelectedSideOptions"
                  :layout="'normal'" />
              </div>

              <Addons 
                class="tw-border-b tw-border-gray-700 tw-py-16"
                :selectedAddons="state.selectedAddons"
                :addons="state.addons"
                @addonToggled="toggleAddon"
              />

              <div class="tw-mt-16">
                <TwButton 
                  cssClass="tw-bg-orange-medium hover:tw-bg-orange-dark tw-border-orange-medium tw-border-2 tw-rounded-full tw-text-white tw-text-3xl tw-uppercase tw-font-bold tw-px-24 tw-mb-4 tw-py-8  tw-transition-all tw-duration-200" 
                  @emit-click="addItem" 
                  :isLoading="state.addingToBag"
                  :isDisabled="false" 
                  :buttonText="addItemText"/>

              </div>

              <div class="tw-mt-12 tw-border-t tw-border-gray-700 tw-py-16" v-if="modularNutritionData">
                <div 
                  class="tw-mb-8 tw-rounded-3xl tw-overflow-hidden tw-cursor-pointer tw-shadow-lg tw-bg-white tw-px-16 tw-py-8 hover:tw-text-orange-medium tw-border tw-border-slate-100" 
                  @click="state.groupDietaryOpen = !state.groupDietaryOpen">
                  <div class="tw-relative tw-pr-24">
                    <h2 class="tw-text-3xl tw-font-bold tw-mr-auto tw-transition-all tw-duration-300">
                      Summary of Allergens and Diets Satisfied
                      <span class="tw-font-normal tw-text-xl tw-pl-4 tw-italic tw-pt-4 ">
                        {{ state.groupDietaryOpen ? 'Click to hide' : 'Click to expand'}}
                      </span>
                    </h2>
                    <span :class="['tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-right-0 fa fa-chevron-right tw-transition tw-inline-block tw-origin-center tw-text-3xl', {'tw-rotate-90': state.groupDietaryOpen}]"></span>
                  </div>
                </div>

                <TwCollapse
                  :duration="200"
                  :collapseOpen="state.groupDietaryOpen">
                  <div class="tw-px-16 tw-pt-8">
                    <div class="tw-mb-6" v-for="og in visibleOptionGroups" :key="og.id">
                      <template v-if="og.parentId == null">
                        <Dietary
                          :group="og.description"
                          :parentOptions="(og.options.filter(opt => opt.isSelected == true ).map((opt) => opt.name).join(','))"
                          :allergens="
                          (
                            calculatedAllergensForGroups && 
                            calculatedAllergensForGroups.get(og.id) && 
                            calculatedAllergensForGroups.get(og.id)!.length > 0
                          ) ? calculatedAllergensForGroups.get(og.id)! as string[] : [] as string[]"
                          :allDiets="calculatedSelectionsInGroup(og.id).length < 1 ? [] as string[] : productDietCodes"
                          :diets="calculatedDietsForGroup && calculatedDietsForGroup.get(og.id) ? calculatedDietsForGroup.get(og.id)! as string[] : [] as string[]"
                          :baseAllergens="groupAllergenLabelBuckets.get(og.id)?.base ?? []"
                          :sideAllergens="groupAllergenLabelBuckets.get(og.id)?.side ?? []"
                          :baseDiets="groupDietLabelBuckets.get(og.id)?.base ?? []"
                          :sideDiets="groupDietLabelBuckets.get(og.id)?.side ?? []"
                          :baseNames="groupSelectionNameBuckets.get(og.id)?.base ?? []"
                          :sideNames="groupSelectionNameBuckets.get(og.id)?.side ?? []"
                          :hasSideItems="groupHasSideSelections.get(og.id) ?? false"
                          :layout="'summary'" />
                      </template>
                    </div>
                  </div>
                </TwCollapse>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref, watch
  } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useCateringOrderStore } from '../../stores/catering_order';
  import { useMenuStore } from '../../stores/menu';
  import { useUserStore } from '../../stores/user';
  import { useFlashMessageStore } from '../../stores/flashMessages';

  import Product from '../../classes/Product';
  import type { OptionNutritionBuckets } from '../../classes/Product';
  import type MenuCategory from '../../classes/MenuCategory'
  import type BasketProduct from '../../classes/BasketProduct';
  import type BasketProductChoice from '../../types/BasketProductChoice';
  import { plainToClass } from 'class-transformer';
  import OptionGroup from './_OptionGroup.vue';
  import Addons from './_Addons.vue';
  import Dietary from './_Dietary.vue';
  import TwCollapse from '../../components/TwCollapse.vue';
  import type OptionGroupInterface from '../../types/OptionGroup';
  import type OptionInterface from '../../types/Option';
  import type ChoiceCustomField from '../../types/ChoiceCustomField';
  import type FlashMessage from '../../types/FlashMessage';

  import SkeletonLoader from '../../components/SkeletonLoader.vue';
  import TwButton from '../../components/TwButton.vue';
  import TwModal from '../../components/TwModal.vue';
  import ProgressBar from '../../components/ProgressBar.vue';
  import NutritionData from '../../classes/NutritionData';

  const basketStore = useBasketStore();
  const cateringOrderStore = useCateringOrderStore();
  const menuStore = useMenuStore();
  const userStore = useUserStore();
  const flashMessageStore = useFlashMessageStore();
  
  const route = useRoute();
  const router = useRouter();

  const state = reactive({
     product: null as (Product | null),
     basketProduct: null as (BasketProduct | null),
     selectedOptions: new Map<number, number>(),
     includedIngredients: new Map<string, number>(),
     quantity: 1,
     addingToBag: false,
     originalAddons: [] as Product[],
     addons: [] as Product[],
     selectedAddons: [] as Product[],
     loadingProduct: true,
     debug: false,
     parentCategory: undefined as (MenuCategory | undefined),
     productOptionDiets: undefined as (OptionNutritionBuckets | undefined),
     productOptionAllergens: undefined as (OptionNutritionBuckets | undefined),
     allergensUnknown: true,
     dietsUnknown: true,
     rootOptions: new Map<number, number[]>(),
     groupDietaryOpen: false,
     recipient: '',
     oloMenuSnapshot: null as (Record<string, unknown> | null),
   })

  type NutritionLabelBucket = {
    base: string[],
    side: string[],
  };

  const createEmptyNutritionBuckets = (): OptionNutritionBuckets => ({
    base: new Map<number, string[]>(),
    onTheSide: new Map<number, string[]>(),
  });

  const combineNutritionBuckets = (buckets: OptionNutritionBuckets): Map<number, string[]> => {
    const combined = new Map<number, string[]>();

    buckets.base.forEach((value, key) => {
      combined.set(key, value ?? []);
    });

    buckets.onTheSide.forEach((value, key) => {
      combined.set(key, value ?? []);
    });

    return combined;
  };

  const selectionKeyForOption = (option: OptionInterface): number => option.inverseId ?? option.id;

  const groupRequiresSelection = (group: OptionGroupInterface | undefined): boolean => {
    if (!group) {
      return false;
    }

    if (group.mandatory) {
      return true;
    }

    const minSelects = typeof group.minselects === 'number' ? group.minselects : 0;
    return minSelects >= 1;
  };

  const shouldAutoSelectOption = (group: OptionGroupInterface, option: OptionInterface): boolean => {
    if (option.isdefault) {
      return true;
    }

    const options = group.options ?? [];
    const hasSingleOption = options.length === 1;

    return hasSingleOption && groupRequiresSelection(group);
  };

  const autoSelectNestedDefaults = (option: OptionInterface) => {
    if (!option.optiongroups || option.optiongroups.length === 0) {
      return;
    }

    option.optiongroups.forEach((group) => {
      if (!group.options || group.options.length === 0) {
        return;
      }

      group.options.forEach((childOption) => {
        if (!shouldAutoSelectOption(group, childOption)) {
          return;
        }

        const selectionKey = selectionKeyForOption(childOption);
        const existingQuantity = state.selectedOptions.get(selectionKey) ?? 0;

        if (existingQuantity > 0) {
          autoSelectNestedDefaults(childOption);
          return;
        }

        const quantity = typeof childOption.quantity === 'number' && childOption.quantity > 0 ? childOption.quantity : 1;

        childOption.isSelected = true;
        childOption.quantity = quantity;
        state.selectedOptions.set(selectionKey, quantity);

        autoSelectNestedDefaults(childOption);
      });
    });
  };

  const getSelectedOptionIds = (): number[] => Array.from(state.selectedOptions.keys());

  const buildParentOptionMap = (product: Product | null): Map<number, number> => {
    const parentMap = new Map<number, number>();

    const visitGroup = (group: OptionGroupInterface, parentOptionId?: number) => {
      if (!group.options || group.options.length === 0) {
        return;
      }

      group.options.forEach((option) => {
        if (typeof parentOptionId === 'number') {
          parentMap.set(option.id, parentOptionId);
        }

        if (option.optiongroups && option.optiongroups.length > 0) {
          option.optiongroups.forEach((nestedGroup) => {
            visitGroup(nestedGroup, option.id);
          });
        }
      });
    };

    if (product?.optiongroups) {
      product.optiongroups.forEach((group) => visitGroup(group));
    }

    return parentMap;
  };

  const buildOptionLookup = (product: Product | null): Map<number, OptionInterface> => {
    const lookup = new Map<number, OptionInterface>();

    const visitGroup = (group: OptionGroupInterface) => {
      if (!group.options || group.options.length === 0) {
        return;
      }

      group.options.forEach((option) => {
        lookup.set(option.id, option);

        if (option.optiongroups && option.optiongroups.length > 0) {
          option.optiongroups.forEach((nestedGroup) => {
            visitGroup(nestedGroup);
          });
        }
      });
    };

    if (product?.optiongroups) {
      product.optiongroups.forEach((group) => visitGroup(group));
    }

    return lookup;
  };

  const optionAllergenBuckets = computed<OptionNutritionBuckets>(() => state.productOptionAllergens ?? createEmptyNutritionBuckets());
  const optionDietBuckets = computed<OptionNutritionBuckets>(() => state.productOptionDiets ?? createEmptyNutritionBuckets());

  const optionAllergenMap = computed(() => combineNutritionBuckets(optionAllergenBuckets.value));
  const optionDietMap = computed(() => combineNutritionBuckets(optionDietBuckets.value));
  const productDietCodes = computed<string[]>(() => state.product?.diets ?? []);
  const optionParentMap = computed(() => buildParentOptionMap(state.product));
  const optionLookupMap = computed(() => buildOptionLookup(state.product));

  const selectedSideCompanionOptionIds = computed<Set<number>>(() => {
    const companions = new Set<number>();
    const sideDietMap = optionDietBuckets.value.onTheSide;
    const sideAllergenMap = optionAllergenBuckets.value.onTheSide;
    const baseDietMap = optionDietBuckets.value.base;
    const baseAllergenMap = optionAllergenBuckets.value.base;

    getSelectedOptionIds().forEach((optionId) => {
      const hasSideDietEntry = sideDietMap.has(optionId);
      const hasSideAllergenEntry = sideAllergenMap.has(optionId);
      const isSideSelection = hasSideDietEntry || hasSideAllergenEntry;

      if (!isSideSelection) {
        return;
      }

      let parentId = optionParentMap.value.get(optionId);

      while (typeof parentId === 'number') {
        const baseDiets = baseDietMap.get(parentId) ?? [];
        const baseAllergens = baseAllergenMap.get(parentId) ?? [];
        const hasBaseNutrition = (baseDiets?.some((diet) => !!diet)) || (baseAllergens?.some((code) => !!code));

        if (!hasBaseNutrition) {
          companions.add(parentId);
        }

        parentId = optionParentMap.value.get(parentId);
      }
    });

    return companions;
  });

  const selectedSideOptionIds = computed<Set<number>>(() => {
    const sideSelections = new Set<number>();
    const sideDietMap = optionDietBuckets.value.onTheSide;
    const sideAllergenMap = optionAllergenBuckets.value.onTheSide;

    getSelectedOptionIds().forEach((optionId) => {
      const hasSideDietEntry = sideDietMap.has(optionId);
      const hasSideAllergenEntry = sideAllergenMap.has(optionId);

      if (hasSideDietEntry || hasSideAllergenEntry) {
        sideSelections.add(optionId);
      }
    });

    return sideSelections;
  });

  const hasSelectedSideOptions = computed(() => selectedSideOptionIds.value.size > 0);

  const groupSelectionNameBuckets = computed<Map<number, NutritionLabelBucket>>(() => {
    const buckets = new Map<number, NutritionLabelBucket>();

    state.rootOptions.forEach((_optionIds, rootId) => {
      const selections = calculatedSelectionsInGroup(rootId) ?? [];

      if (selections.length === 0) {
        buckets.set(rootId, { base: [], side: [] });
        return;
      }

      const baseNames = new Set<string>();
      const sideNames = new Set<string>();

      selections.forEach((optionId) => {
        const option = optionLookupMap.value.get(optionId);
        const name = option?.name?.trim();

        if (!name) {
          return;
        }

        if (selectedSideOptionIds.value.has(optionId)) {
          sideNames.add(name);
        } else {
          baseNames.add(name);
        }
      });

      buckets.set(rootId, {
        base: Array.from(baseNames),
        side: Array.from(sideNames),
      });
    });

    return buckets;
  });

  const overallBaseOptionNames = computed(() => {
    const names = new Set<string>();
    groupSelectionNameBuckets.value.forEach((bucket) => {
      bucket.base.forEach((name) => names.add(name));
    });
    return Array.from(names);
  });

  const overallSideOptionNames = computed(() => {
    const names = new Set<string>();
    groupSelectionNameBuckets.value.forEach((bucket) => {
      bucket.side.forEach((name) => names.add(name));
    });
    return Array.from(names);
  });

  const allergenCodesToLabels = (codes: string[]): string[] => {
    const labels: string[] = [];
    codes.forEach((code) => {
      if (code) {
        const label = NutritionData.allergens[code as keyof typeof NutritionData.allergens];
        if (typeof label === 'string' && label.length > 0) {
          labels.push(label);
        }
      }
    });
    return Array.from(new Set(labels));
  };

  const dietCodesToLabels = (codes: string[]): string[] => {
    const labels: string[] = [];
    codes.forEach((code) => {
      if (code) {
        const label = NutritionData.diets[code as keyof typeof NutritionData.diets];
        if (typeof label === 'string' && label.length > 0) {
          labels.push(label);
        }
      }
    });
    return Array.from(new Set(labels));
  };

  const baseAllergenCodes = computed(() => {
    const codes = new Set<string>();

    if (state.product?.allergens) {
      state.product.allergens.forEach((code) => {
        if (code) {
          codes.add(code);
        }
      });
    }

    const baseMap = optionAllergenBuckets.value.base;
    const sideMap = optionAllergenBuckets.value.onTheSide;
    getSelectedOptionIds().forEach((optionId) => {
      if (selectedSideCompanionOptionIds.value.has(optionId)) {
        return;
      }

      if (sideMap.has(optionId)) {
        return;
      }

      const optionValues = baseMap.get(optionId);
      if (optionValues && optionValues.length > 0) {
        optionValues.forEach((code) => {
          if (code) {
            codes.add(code);
          }
        });
      }
    });

    return Array.from(codes);
  });

  const sideAllergenCodes = computed(() => {
    const codes = new Set<string>();
    const sideMap = optionAllergenBuckets.value.onTheSide;

    getSelectedOptionIds().forEach((optionId) => {
      const optionValues = sideMap.get(optionId);
      if (optionValues && optionValues.length > 0) {
        optionValues.forEach((code) => {
          if (code) {
            codes.add(code);
          }
        });
      }
    });

    return Array.from(codes);
  });

  const baseAllergenLabels = computed(() => allergenCodesToLabels(baseAllergenCodes.value));
  const sideAllergenLabels = computed(() => allergenCodesToLabels(sideAllergenCodes.value));

  const baseDietCodes = computed(() => {
    let diets: string[] | null = productDietCodes.value.length > 0 ? [...productDietCodes.value] : null;

    const baseMap = optionDietBuckets.value.base;
    const sideMap = optionDietBuckets.value.onTheSide;

    getSelectedOptionIds().forEach((optionId) => {
      if (selectedSideCompanionOptionIds.value.has(optionId)) {
        return;
      }

      if (sideMap.has(optionId)) {
        return;
      }

      if (!baseMap.has(optionId)) {
        return;
      }

      const optionValues = (baseMap.get(optionId) ?? []).filter((diet): diet is string => typeof diet === 'string' && diet.length > 0);

      if (optionValues.length === 0) {
        diets = [];
        return;
      }

      if (diets === null) {
        diets = [...optionValues];
        return;
      }

      diets = diets.filter((diet) => optionValues.includes(diet));
    });

    const finalDiets = diets ?? [];
    const unique = new Set<string>();
    finalDiets.forEach((diet) => {
      if (diet) {
        unique.add(diet);
      }
    });

    return Array.from(unique);
  });

  const sideDietCodes = computed(() => {
    const codes = new Set<string>();
    const sideMap = optionDietBuckets.value.onTheSide;

    getSelectedOptionIds().forEach((optionId) => {
      const optionValues = sideMap.get(optionId);
      if (optionValues && optionValues.length > 0) {
        optionValues.forEach((diet) => {
          if (diet) {
            codes.add(diet);
          }
        });
      }
    });

    return Array.from(codes);
  });

  const baseDietLabels = computed(() => dietCodesToLabels(baseDietCodes.value));
  const sideDietLabels = computed(() => dietCodesToLabels(sideDietCodes.value));

   const showRecipientField = computed(() => {
    if (!state.parentCategory) {
      return false;
    }

    const metaValue = state.parentCategory.getMetaDataByKey('showNameField');
    if (metaValue !== null && metaValue !== undefined) {
      return metaValue;
    }

    return false;
  });

  const recipientRequired = computed(() => {
    if (!state.parentCategory) {
      return false;
    }

    const metaValue = state.parentCategory.getMetaDataByKey('nameIsRequired');
    if (metaValue !== null && metaValue !== undefined) {
      return metaValue;
    }

    return false;
  });

  watch(showRecipientField, (visible) => {
    if (!visible) {
      state.recipient = '';
    }
  });

  const showQuantityNameConfirm = ref(false);
  const skipRecipientQuantityCheck = ref(false);

  const handleQuantityConfirmCancel = () => {
    showQuantityNameConfirm.value = false;
    skipRecipientQuantityCheck.value = false;
  };

  const handleQuantityConfirmContinue = () => {
    skipRecipientQuantityCheck.value = true;
    showQuantityNameConfirm.value = false;
    addItem();
  };



  // Runs through the product data and sets up default selection states and flattens as needed

  const initializeProduct = ((product: Product) => {
    let vm = this;
    const prod = product;

    let ogs = [] as OptionGroupInterface[];

    if (product.optiongroups && product.optiongroups.length > 0) {
      product.optiongroups.forEach((og) => {
        const desc = og.description.toLowerCase()
        if (og.description.toLowerCase() == "included ingredients") {
          og.options.forEach((option: OptionInterface) => {
            state.includedIngredients.set(option.name.toLowerCase().replace('no ', ''), option.id)
          });
        }
        // Todo: Map extra proteins to regular

        const fog = flattenedOptionGroup(og);
        const preselectedGroups = preSelectOptionsForGroup(fog);
        ogs = ogs.concat(preselectedGroups);
      })

      // Set root option group ids
      let rootId = undefined as (number | undefined);
      let rootOptions = new Map<number, number[]>()
      ogs.forEach((og) => {
        if (og.parentId == null) {
          rootId = og.id;
          rootOptions.set(og.id, []);
        } else if (rootId) {
          og.rootGroupId = rootId;
        }

        if (og.options && rootId && rootOptions.get(rootId)) {
          og.options.forEach((opt) => {
            rootOptions.get(rootId!)!.push(opt.id);
          })
        }
      })
      state.rootOptions = rootOptions;
    }


    if (prod.custom_data && prod.custom_data.addon_products) {
      let prods = JSON.parse(prod.custom_data.addon_products);
      // Loop over the addons and get the full products
      Object.entries(prods).forEach((addonArr: Array<any>) => {
        menuStore.getProductByChainId(addonArr[0]).then((addonProduct: Product) => {
          if (addonProduct) {
            addonProduct.quantity = addonArr[1];
            state.originalAddons.push(addonProduct);
            state.addons.push(addonProduct);
          }
        })
      })
    }

    if (state.basketProduct) {
      prod.optiongroups = preSelectBasketChoices(ogs);
    } else {
      prod.optiongroups = ogs;
      if (route.query.quantity) {
        state.quantity = parseFloat(route.query.quantity.toString());
      }
    }

    state.product = prod;

    state.allergensUnknown = product.allergens == null || product.allergens == undefined
    state.dietsUnknown = product.diets == null || product.diets == undefined

    const optionDietBuckets = prod.optionsNutrition("dietary")
    const optionAllergenBuckets = prod.optionsNutrition("allergens")

    state.productOptionDiets = optionDietBuckets
    state.productOptionAllergens = optionAllergenBuckets

    setProductBreadcrumbCategory()

    state.loadingProduct = false;
  })

  const preSelectOptionsForGroup = ((ogs: OptionGroupInterface[]): OptionGroupInterface[] => {
    let isBasketProduct = typeof(route.params.bpid) != "undefined";

    ogs.forEach((og) => {
      og.options.forEach((option: OptionInterface) => {
        let shouldSelect = false;
        // Check if the option is a default
        const isRootGroup = og.parentId == null;
        const canAutoSelect = shouldAutoSelectOption(og, option);
        if (!isBasketProduct && isRootGroup && canAutoSelect && (option.inverseId == null || option.inverseId == undefined)) {
          shouldSelect = true;
        }

        if (shouldSelect) {
          const selectionKey = selectionKeyForOption(option);
          if (!state.selectedOptions.has(selectionKey)) {
            const quantity = typeof option.quantity === 'number' && option.quantity > 0 ? option.quantity : 1;
            option.isSelected = true;
            option.quantity = quantity;
            state.selectedOptions.set(selectionKey, quantity);
          }

          autoSelectNestedDefaults(option);
        }
      })
    })

    return ogs;
  })

  const preSelectBasketChoices = ((ogs: OptionGroupInterface[]): OptionGroupInterface[] => {
    const mappedBasketChoices = state.basketProduct!.choices.map((choice: BasketProductChoice) => {
      return choice.optionid
    })
    // We'll loop over the choices and figure out selections
    ogs.forEach((og: OptionGroupInterface) => {
      if ((og.description.toLowerCase() != "included ingredients") && og.options) {
        og.options.forEach((opt: OptionInterface) => {
          if (mappedBasketChoices.includes(opt.id) || mappedBasketChoices.includes(opt.inverseId) ) {

            // We have to get the exact basket choice to confirm option quantity
            let bpchoice = state.basketProduct!.choices.find((choice: BasketProductChoice) => {
              if (opt.inverseId != null && opt.inverseId != undefined) {
                return choice.optionid == opt.inverseId;
              } else {
                return choice.optionid == opt.id;
              }
            })

            if (bpchoice) {
              if (opt.inverseId != null && opt.inverseId != undefined) {
                opt.isSelected = false;
                opt.quantity = 0;
                if (state.selectedOptions.has(opt.id)) {
                  // Set qty 0 and loop back over to set the basket choice qty
                  state.selectedOptions.set(opt.id, 0)
                } 
                for(let i = 0; i < bpchoice.quantity; i++){
                  selectOption(opt)
                }
              } else {
                opt.isSelected = true;
                opt.quantity = bpchoice.quantity;
                if (state.selectedOptions.has(opt.id)) {
                  // Set qty 0 and loop back over to set the basket choice qty
                  state.selectedOptions.set(opt.id, 0)
                } 

                for(let i = 0; i < bpchoice.quantity; i++){
                  selectOption(opt)
                }
              }
            }
          }
        })
      }
    })

    return ogs
  })

  // Given an option group, will loop through nested options to look for nested option groups
  // Returns an array of all option groups nested under the option group
  const flattenedOptionGroup = ((og: OptionGroupInterface): OptionGroupInterface[] => {
    let isBasketProduct = typeof(route.params.bpid) != "undefined";
    let flattenedOgs = [og] as OptionGroupInterface[];
    if (og.options && og.options.length > 0) {
      og.options.forEach((opt: OptionInterface) => {
        if (state.includedIngredients) {
          const isIncluded = state.includedIngredients.has(opt.name.toLowerCase());
          if (isIncluded) {
            opt.isSelected = isIncluded;
            opt.inverseId = state.includedIngredients.get(opt.name.toLowerCase())!
          } else if (!isBasketProduct && og.parentId == null && shouldAutoSelectOption(og, opt)) {
            opt.isSelected = true
          }
        }

        if (opt.optiongroups && opt.optiongroups.length > 0) {
          opt.optiongroups.forEach((og2: OptionGroupInterface) => {
            og2.parentId = opt.id;

            flattenedOgs = flattenedOgs.concat(flattenedOptionGroup(og2));
          })
        }
      })
    }

    return flattenedOgs;
  })

  const selectOption = ((option: OptionInterface) => {
    const selectionKey = selectionKeyForOption(option);
    const existingQuantity = state.selectedOptions.get(selectionKey) ?? 0;
    const nextQuantity = existingQuantity + 1;

    option.isSelected = true;
    option.quantity = nextQuantity;
    state.selectedOptions.set(selectionKey, nextQuantity);

    autoSelectNestedDefaults(option);
  })

  const removeOption = ((option: OptionInterface) => {
    const selectionKey = selectionKeyForOption(option);
    const existingQuantity = state.selectedOptions.get(selectionKey);

    if (typeof existingQuantity !== 'number') {
      return;
    }

    if (existingQuantity > 1) {
      const nextQuantity = existingQuantity - 1;
      option.quantity = nextQuantity;
      state.selectedOptions.set(selectionKey, nextQuantity);
    } else {
      state.selectedOptions.delete(selectionKey);
      option.quantity = 0;
      option.isSelected = false;

      if (option.inverseId == null) {
        deselectChildOptions(option);
      }
    }
  })

  const toggleAddon =  ((addon: Product) => {
    const selectedIndex = state.selectedAddons.map(sel => sel.id).indexOf(addon.id);
    if (selectedIndex > -1) {
      const idx = selectedIndex;
      state.selectedAddons.splice(idx, 1);
    } else {
      state.selectedAddons.push(addon)
    }
  })

  const deselectChildOptions = ((option: OptionInterface) => {
    if (option.optiongroups && option.optiongroups.length > 0) {
      option.optiongroups.forEach((og: OptionGroupInterface) => {
        if (og.options && og.options.length > 0) {
          og.options.forEach((opt: OptionInterface) => {
            if (opt.isSelected) {
              if (opt.quantity > 1) {
                for(let i=0; i < opt.quantity; i++) {
                  removeOption(opt);
                }
              } else {
                removeOption(opt);
              }
              opt.isSelected = false;
            }
          })
        }
      })
    }
  })

  const addItem = () => {
    const trimmedRecipient = state.recipient.trim();

    if (recipientRequired.value && showRecipientField.value && trimmedRecipient.length === 0) {
      popError('Please enter a name before adding this item.', 'Name Required');
      return;
    }

    const bypassQuantityCheck = skipRecipientQuantityCheck.value;
    skipRecipientQuantityCheck.value = false;

    if (!bypassQuantityCheck && state.quantity > 1 && trimmedRecipient.length > 0) {
      showQuantityNameConfirm.value = true;
      return;
    }

    if (state.product) {
      const recipientPayload = showRecipientField.value ? trimmedRecipient : '';
      state.addingToBag = true;
      let options = [] as number[];
      let choicecustomfields = [] as ChoiceCustomField[];
      if (state.selectedOptions) {
        // Loop over options to add them with quantities if necessary
        state.selectedOptions.forEach((qty,id) => {
          if (qty > 1) {
            options.push(id);
            choicecustomfields.push({choiceid: id, quantity: qty} as ChoiceCustomField)
          } else {
            options.push(id);
          }
        })
      }

      // We update the basket item
      if (state.basketProduct) {
        basketStore.updateProduct(state.product.id!.toString(), state.basketProduct.id.toString(), state.quantity, "", options, choicecustomfields, recipientPayload).then(() => {
          if (state.selectedAddons && state.selectedAddons.length > 0) {
            let addonsAdded = 0;
            state.selectedAddons.forEach((addon: Product) => {
              basketStore.addProduct(addon.id!.toString(), addon.quantity, "", [], [], undefined).then(() => {
                addonsAdded += 1;
                if (addonsAdded == state.selectedAddons.length) {
                  state.addingToBag = false;
                  flashMessageStore.dismissErrors();
                  router.push('/menu')
                }
              })
            })
          } else {
            state.addingToBag = false;
            flashMessageStore.dismissErrors();
            router.push('/menu')
          }
        }).catch((error: Error) => {
          popError(error.message, "Error Adding Item");
          state.addingToBag = false;
        })
      } else {
        // Kick off the product add call, if it succeeds we can try to also add the addon products
        basketStore.addProduct(state.product.id!.toString(), state.quantity, "", options, choicecustomfields, undefined, recipientPayload).then(() => {
          if (state.selectedAddons && state.selectedAddons.length > 0) {
            let addonsAdded = 0;
            state.selectedAddons.forEach((addon: Product) => {
              basketStore.addProduct(addon.id!.toString(), addon.quantity, "", [], [], undefined).then(() => {
                addonsAdded += 1;
                if (addonsAdded == state.selectedAddons.length) {
                  completeProductAdd()
                }
              })
            })
            
          } else {
            completeProductAdd()
          }
        }).catch((error: Error) => {
          popError(error.message, "Error Adding Item");
          state.addingToBag = false;
        })
      }
    } else {
      // We have problems
      popError("Item could not be added. Please make sure all required selections have been made and try again.", "Error Adding Item");
      state.addingToBag = false;
    }
  };

  const popError = (error: string, title: string) => {
    const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "danger",
        text: error,
        headline: title,
        delay: 0, // ms
        icon: "",
        cssClass: "",
    } as FlashMessage;
    flashMessageStore.addMessage(message);
  }

  const completeProductAdd = (() => {
    flashMessageStore.dismissErrors();
    const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "success",
        text: "Product has been added to bag",
        headline: "",
        delay: 5000, // ms
        icon: "",
        cssClass: "",
    } as FlashMessage;
    flashMessageStore.addMessage(message);

    state.addingToBag = false;
    router.push('/menu')
  })

  const decrementQuantity = () => {
    state.quantity = Math.max(state.quantity -= 1, 1);
  };

  const incrementQuantity = () => {
    state.quantity = Math.min(state.quantity += 1, 99);
  };

  watch(() => state.quantity, (newQty, oldQty) =>  {
    updateAddonQuantity(newQty);
  })

  const updateAddonQuantity = ((updatedQuantity: number) => {
    let dupedAddons = JSON.parse(JSON.stringify(state.originalAddons)) as Product[]

    dupedAddons.forEach((addon: Product) => {
      addon.quantity = Math.round((addon.quantity * updatedQuantity));
      if (state.selectedAddons) {
        // Check to see if this addon is selected, and up the selected addon to match quantity
        const match = state.selectedAddons.find((selAddon: Product) => {
          return selAddon.id == addon.id
        })

        if (match) {
          match.quantity = addon.quantity;
        }
      }
    })

    state.addons = dupedAddons;
  })

  const setProductBreadcrumbCategory = () => {
    let category = undefined as (MenuCategory | undefined);

    // We'll have to search through the menu to find the category this item is in
    menuStore.menu.forEach((cat: MenuCategory) => {
      if (cat.products && cat.products.length > 0) {
        const matchedProduct = cat.products.find((prod: Product) => {
          return prod.id == state.product!.id;
        })

        if (matchedProduct) {
          category = cat;
        }
      }
    })

    state.parentCategory = category;
  }
 
  const currentPrice = computed(() => {
    let calculatedCost = 0.00;

    if (state.product) {
      calculatedCost += state.product.cost as number;

      state.product.optiongroups!.forEach((og: OptionGroupInterface) => {
        og.options.forEach((opt: OptionInterface) => {
          if (opt.isSelected && opt.cost > 0) {
            const quantity = opt.quantity > 0 ? opt.quantity : 1;
            calculatedCost += opt.cost * quantity;
          }
        });
      });
    }

    if (state.selectedAddons && state.selectedAddons.length > 0) {
      state.selectedAddons.forEach((addon: Product) => {
        calculatedCost += (addon.cost as number) * addon.quantity;
      });
    }

    return calculatedCost * state.quantity;
  });

  const currentAllergens = computed(() => {
    const combined = [...baseAllergenLabels.value, ...sideAllergenLabels.value];
    return Array.from(new Set(combined));
  });

  const currentDietary = computed(() => {
    const combined = [...baseDietLabels.value, ...sideDietLabels.value];
    return Array.from(new Set(combined));
  });

  const productHero = computed(() => {
    let img: string | null = null;

    if (state.product && state.product.images) {
      const imageByKey = state.product.getImageByKey('product_web_block');
      if (imageByKey) {
        img = imageByKey.url;
      } else {
        img = 'https://mypiada-assets.s3.amazonaws.com/static_assets/scooter-placeholder.jpg';
      }
    }

    return img;
  });

  // Count selected options and how many guests they feed
  const optionsFeed = computed(() => {
    let feeds = 0;
    // TODO: Add this back when the basket can handle options having a feeds property
    // let optionFeedsMap = new Map<number, number>();

    // if (state.product && state.product.optiongroups) {
    //   state.product.optiongroups.forEach((og: OptionGroupInterface) => {
    //     if (og.options && og.options.length > 0) {
    //       og.options.forEach((opt: OptionInterface) => {
    //         if (opt.feeds && opt.feeds != 0 && opt.isSelected) {
    //           if (opt.quantity && opt.quantity > 1) {
    //             feeds += Math.round((opt.feeds * opt.quantity))
    //           } else {
    //             feeds += opt.feeds
    //           }
    //         }
    //       })
    //     }
    //   })
    // }

    return feeds;
  })

  const metaFeeds = computed(() => {
    let feeds = 0

    let count = 0;
    let lightFeeds = 0;
    let regularFeeds = 0;
    let hungryFeeds = 0;
    let lightPct = 0;
    let regularPct = 0;
    let hungryPct = 0;
    let totalGuests = 0;

    if (cateringOrderStore.cateringOrder) {
      totalGuests = cateringOrderStore.cateringOrder.guest_count;
    }

    if (totalGuests && totalGuests > 0) {
      lightPct = (guestHungerArray.value.at(0)!) / totalGuests;
      regularPct = (guestHungerArray.value.at(1)!) / totalGuests;
      hungryPct = (guestHungerArray.value.at(2)!) / totalGuests;
    } else {
      regularPct = 1;
    }


    if (state.product && state.product.feeds) {
      lightFeeds += (state.product.feeds.at(0)!);
      regularFeeds += (state.product.feeds.at(1)!);
      hungryFeeds += (state.product.feeds.at(2)!);
    }

    let feedsLight = lightFeeds * lightPct;
    let feedsRegular = regularFeeds * regularPct;
    let feedsHungry = hungryFeeds * hungryPct;

    let feedsAmount = Math.round(feedsLight + feedsRegular + feedsHungry);
    count += feedsAmount * state.quantity;

    return count;
  })

  const guestHungerArray = computed(() => {
    if (cateringOrderStore.cateringOrder) {
      return [cateringOrderStore.cateringOrder!.light_eaters, cateringOrderStore.cateringOrder!.regular_eaters, cateringOrderStore.cateringOrder!.hungry_eaters];
    } else {
      return [0,0,0];
    }
  })

  const baselineCovered = computed(() => {
    if (cateringOrderStore.cateringOrder!.guest_count && basketStore.basket) {
      let currentlyFeeds = basketStore.basket.basketFeeds(guestHungerArray.value, cateringOrderStore.cateringOrder!.guest_count, undefined);

      if (route.params.bpid && typeof(route.params.bpid) == 'string') {
        const bpid: string = route.params.bpid;
        currentlyFeeds = basketStore.basket.basketFeeds(guestHungerArray.value, cateringOrderStore.cateringOrder!.guest_count, bpid);
      }

      return Math.min(((currentlyFeeds/cateringOrderStore.cateringOrder!.guest_count)*100), 100);
    } else {
      return 0;
    }
  })

  const percentageAccountedFor = computed(() => {
    if (cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder.guest_count == undefined || cateringOrderStore.cateringOrder && cateringOrderStore.cateringOrder!.guest_count < 1)  {
      return 100;
    } else if (metaFeeds.value && cateringOrderStore.cateringOrder!.guest_count) {
      return Math.min(((metaFeeds.value/cateringOrderStore.cateringOrder!.guest_count)*100), 100);
    } else {
      return 0;
    }
  })

  const totalFed = computed(() => {
    let count = 0;
    let baskFeeds = null;
    if (basketStore.basket) {

      if (route.params.bpid) {
        baskFeeds = basketStore.basket!.basketFeeds(guestHungerArray.value, cateringOrderStore.cateringOrder!.guest_count, route.params.bpid!.toString());
      } else {
        baskFeeds = basketStore.basket!.basketFeeds(guestHungerArray.value, cateringOrderStore.cateringOrder!.guest_count, undefined);
      }
    }

    if (metaFeeds) {
      count += metaFeeds.value!
    }
    
    if (baskFeeds) {
      count += baskFeeds
    }

    return count;
  })

  const modularNutritionData = computed(() => {
    return state.product && state.product.quick_combo_item == true;
  })

  const visibleNestedGroupIds = computed(() => {
    let groupIds = new Map() as (Map<number, number[]>);
    let currentRoot = undefined as (number | undefined);

    if (visibleOptionGroups.value && visibleOptionGroups.value.length > 0) {
      visibleOptionGroups.value.forEach((og) => {
        if (og.parentId == null) {
          currentRoot = og.id;
          groupIds!.set(og.id, []);
        }
        if (currentRoot && groupIds && groupIds!.get(currentRoot)) {
          groupIds!.get(currentRoot)!.push(og.id);
        }
      })
    }

    return groupIds;
  })

  const visibleOptionGroups = computed(() => {
    let ogs = [] as OptionGroupInterface[]

    if (state.product && state.product.optiongroups) {
      state.product!.optiongroups.forEach((og) => {
        let visible = true;

        if (og.description.toLowerCase() == "included ingredients") {
          visible = false
        } else if (og.parentId != null && og.parentId != undefined) {
          // If the option group has a parent, that parent needs to either be selected or a inverted unselected option
          // TODO: Check for inverted unselected state on aprent
          visible = (state.selectedOptions.has(og.parentId));
        }

        if (visible) {
          ogs.push(og);
        }
      })
    }

    return ogs;
  })

  const calculatedSelectionsInGroup = ((rootId: number) => {
    // Get all the selected options that are in the root group and nested
    let allOptions = state.rootOptions.get(rootId);
    let selectedOpts = Array.from(state.selectedOptions.keys());
    let selectedGroupOptions = [] as number[];
    if (allOptions && allOptions.length > 0 && selectedOpts) {
      selectedGroupOptions = allOptions.filter(opt => selectedOpts.includes(opt));
    }

    return selectedGroupOptions;
  })

  const groupAllergenLabelBuckets = computed<Map<number, NutritionLabelBucket>>(() => {
    const baseMap = optionAllergenBuckets.value.base;
    const sideMap = optionAllergenBuckets.value.onTheSide;
    const buckets = new Map<number, NutritionLabelBucket>();

    state.rootOptions.forEach((_optionIds, rootId) => {
      const selections = calculatedSelectionsInGroup(rootId);

      if (!selections || selections.length === 0) {
        buckets.set(rootId, { base: [], side: [] });
        return;
      }

      const baseCodes = new Set<string>();
      const sideCodes = new Set<string>();

      selections.forEach((optId) => {
        if (selectedSideCompanionOptionIds.value.has(optId)) {
          return;
        }

        const optionBaseCodes = baseMap.get(optId);
        if (optionBaseCodes && optionBaseCodes.length > 0) {
          optionBaseCodes.forEach((code) => {
            if (code) {
              baseCodes.add(code);
            }
          });
        }

        const optionSideCodes = sideMap.get(optId);
        if (optionSideCodes && optionSideCodes.length > 0) {
          optionSideCodes.forEach((code) => {
            if (code) {
              sideCodes.add(code);
            }
          });
        }
      });

      buckets.set(rootId, {
        base: allergenCodesToLabels(Array.from(baseCodes)),
        side: allergenCodesToLabels(Array.from(sideCodes)),
      });
    });

    return buckets;
  });

  const groupHasSideSelections = computed(() => {
    const map = new Map<number, boolean>();

    state.rootOptions.forEach((_optionIds, rootId) => {
      const selections = calculatedSelectionsInGroup(rootId);
      const hasSide = selections.some((optId) => selectedSideOptionIds.value.has(optId));
      map.set(rootId, hasSide);
    });

    return map;
  });

  const groupDietLabelBuckets = computed<Map<number, NutritionLabelBucket>>(() => {
    const baseMap = optionDietBuckets.value.base;
    const sideMap = optionDietBuckets.value.onTheSide;
    const buckets = new Map<number, NutritionLabelBucket>();

    state.rootOptions.forEach((_optionIds, rootId) => {
      const selections = calculatedSelectionsInGroup(rootId);

      if (!selections || selections.length === 0) {
        buckets.set(rootId, { base: [], side: [] });
        return;
      }

      let baseCodes: string[] | null = productDietCodes.value.length > 0 ? [...productDietCodes.value] : null;

      selections.forEach((optId) => {
        if (selectedSideCompanionOptionIds.value.has(optId)) {
          return;
        }

        if (!baseMap.has(optId)) {
          return;
        }

        const optionValues = (baseMap.get(optId) ?? []).filter((diet): diet is string => typeof diet === 'string' && diet.length > 0);

        if (optionValues.length === 0) {
          baseCodes = [];
          return;
        }

        if (baseCodes === null) {
          baseCodes = [...optionValues];
          return;
        }

        baseCodes = baseCodes.filter((diet) => optionValues.includes(diet));
      });

      const sideCodes = new Set<string>();
      selections.forEach((optId) => {
        const optionValues = sideMap.get(optId);
        if (optionValues && optionValues.length > 0) {
          optionValues.forEach((diet) => {
            if (diet) {
              sideCodes.add(diet);
            }
          });
        }
      });

      buckets.set(rootId, {
        base: dietCodesToLabels(baseCodes ?? []),
        side: dietCodesToLabels(Array.from(sideCodes)),
      });
    });

    return buckets;
  });

  const calculatedAllergensForGroups = computed(() => {
    const rootIds = Array.from(state.rootOptions.keys());
    const optionAllergens = optionAllergenMap.value;
    const allergensPerGroup = new Map<number, string[]>();

    rootIds.forEach((rootId) => {
      allergensPerGroup.set(rootId, []);

      const selections = calculatedSelectionsInGroup(rootId);
      if (selections && selections.length > 0) {
        let allergens: string[] = [];

        selections.forEach((optId) => {
          if (optionAllergens.has(optId)) {
            const optionValues = optionAllergens.get(optId);
            if (optionValues && optionValues.length > 0) {
              allergens = allergens.concat(optionValues);
            }
          }
        });

        const uniqueAllergens = [...new Set(allergens)];
        if (allergensPerGroup.get(rootId)) {
          uniqueAllergens.forEach((allergy) => {
            const label = NutritionData.allergens[allergy as keyof typeof NutritionData.allergens];
            if (label) {
              allergensPerGroup.get(rootId)!.push(label);
            }
          });
        }
      }
    });

    return allergensPerGroup;
  })

  const calculatedDietsForGroup = computed(() => {
    const rootIds = Array.from(state.rootOptions.keys());
    const optionDiets = optionDietMap.value;
    const dietsPerGroup = new Map<number, string[]>();
    let dietsUnknown = false;

    rootIds.forEach((rootId) => {
      dietsPerGroup.set(rootId, []);
      let diets = Object.keys(NutritionData.diets) as string[];

      const selections = calculatedSelectionsInGroup(rootId);
      if (selections && selections.length > 0) {
        selections.forEach((optId) => {
          if (selectedSideCompanionOptionIds.value.has(optId)) {
            return;
          }

          if (optionDiets.has(optId)) {
            const optionValues = optionDiets.get(optId);
            if (optionValues && optionValues.length > 0) {
              diets = diets.filter((diet) => optionValues.includes(diet));
            } else {
              diets = [];
            }
          } else {
            dietsUnknown = true;
          }
        });

        const uniqueDiets = [...new Set(diets)];
        if (dietsPerGroup.get(rootId)) {
          uniqueDiets.forEach((diet) => {
            const label = NutritionData.diets[diet as keyof typeof NutritionData.diets];
            if (label) {
              dietsPerGroup.get(rootId)!.push(label);
            }
          });
        }
      }
    });

    return dietsUnknown ? new Map<number, string[]>() : dietsPerGroup;
  })

  const getRootGroupId = (optionGroup: OptionGroupInterface) => (optionGroup.rootGroupId == null ? optionGroup.id : optionGroup.rootGroupId);

  const shouldDisplayGroupNestedNutrition = ((id: number, rootId: number) => {
    let show = false;

    if (visibleNestedGroupIds.value) {
      let groups = visibleNestedGroupIds.value.get(rootId);
      if (groups && groups.length > 0) {
        show = groups[groups.length - 1] == id;
      }
    }

    return show;
  })

  const beginCustomizeView = (() => {
    if (route.params.bpid) {
      let basketProduct = undefined as (BasketProduct | undefined);

      if (route.params.bpid) {
        if (basketStore.basket && basketStore.basket.products) {
           basketProduct = basketStore.basket!.products.find((bp: BasketProduct) => {
            return bp.id.toString() == route.params.bpid;
          })
        } else {
          // Try to get the basket again
          basketStore.fetchBasketWithPromise(localStorage.getItem('mypiadaBasketId')!).then(() => {
            basketProduct = basketStore.basket!.products.find((bp: BasketProduct) => {
              return bp.id.toString() == route.params.bpid;
            })
          });
        }
      }

      if (basketProduct) {
        state.basketProduct = basketProduct as BasketProduct;
        state.quantity = state.basketProduct.quantity
        state.recipient = state.basketProduct.recipient || '';
      }
    }
  
    menuStore.getProduct(parseFloat(route.params.id.toString())).then((product: Product) => {
      initializeProduct(plainToClass(Product, (product as object)) as Product)
    }) // menuStore.fetchProduct(parseFloat(route.params.id.toString()))
  })

  const addItemText = computed(() => {
    let txt = state.basketProduct != null ? 'Update Item' : 'Add To Order';
    if (state.product && state.product.cost) {
      txt += ' - $' + (currentPrice.value.toLocaleString("en-US", {minimumFractionDigits: 2}));
    }
    return txt;
  })

  onMounted(() => {
    // Make sure we have a menu first
    if (userStore.userLocation) {
      if (menuStore.menu && menuStore.menuLocation) {
        beginCustomizeView()
      } else {
        menuStore.fetchMenu(parseFloat(userStore.userLocation.extref)).then(() => {
          beginCustomizeView()
        })
      }
    } else {
      const message = {
        id: Math.round(Date.now() / 1000),
        messageType: "danger",
        text: "You must select a location",
        headline: "Error",
        delay: 0, // ms
        icon: "",
        cssClass: "",
      } as FlashMessage;
      flashMessageStore.addMessage(message);
      router.push('wizard');
    }
  })

</script>

<style>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button,
input[type='number'] {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  -moz-appearance: textfield !important;
}
</style>